// extracted by mini-css-extract-plugin
export default {"logoCell":"UtilitySetupPage_logoCell__rne46","logo":"UtilitySetupPage_logo__BLaMc","subDomain":"UtilitySetupPage_subDomain__ReaRA"};